window.UpdateCashbackAndRewardsForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            messages: {
                invalidAccountName: '#invalid-account-name',
                invalidSortCode: '#invalid-sort-code',
                invalidAccountNumber: '#invalid-account-number',
                incompleteAccountName: '#incomplete-account-name',
                incompleteSortCode: '#incomplete-sort-code',
                incompleteAccountNumber: '#incomplete-account-number',
                invalidCombination: '#invalid-combination'
            },
            textBox: {
                accountName: '#member-form-account-name-input',
                sortCode: '#member-form-sort-code-input',
                accountNumber: '#member-form-account-number-input'
            },
        },
        urls: {
            sendFormDataUrl: '/api/sitecore/UpdateCashbackAndRewards/UpdateCashbackBankDetails',
            getBankDetailsUrl: '/api/sitecore/PaymentDetails/GetCashBackBankDetails',
            errorPageUrl: '/error/error-page',
            securityAndPaymentsPageUrl: '/my-account/security',
            validateBankDetails: '/api/sitecore/ValidateBankDetails/ValidateBankDetails'
        },
        constants: {
            NoUpdateMessageCode: 'NoUpdate',
            AccountNameMaxLength: 18,
            AccountNameMinimumLength: 2,
            AllowedAccountNameRegex: '^[A-Za-z0-9 .\\-&/]+$',
            NumberOnlyRegex: '^[0-9]+$',
            NotNumberRegexGlobal: /[^0-9]/g,
            AccountNumberRequiredLength: 8,
            SortCodeRequiredLength: 6,
            CharCodeUnitSeperator: 31,
            CharCodeNumericLowerBound : 48,
            CharCodeNumericUpperBound: 57,
            SuccessMessageCode: '1'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        css: {
            vdsHiddenItem: 'vds-item-hidden'
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.hideInvalidMessage();

                $.ajax({
                    url: self.urls.getBankDetailsUrl,
                    type: 'GET'
                });
                //This call is made to ensure bank details are cached on the bank end

            },
            bindings: function () {
                $('#member-form').on('submit', self.func.handleSaveMemberCashBackandRewardDetails);
                $(self.elements.textBox.sortCode + ',' + self.elements.textBox.accountNumber).on('keypress', self.func.allowOnlyNumbers);
                $(self.elements.textBox.sortCode).on('paste', self.func.allowPastingofSortCodeNumbers);
                $(self.elements.textBox.accountNumber).on('paste', self.func.allowPastingofAccountNumbers);

                $(self.elements.textBox.accountName).on('keypress', self.func.allowOnlyAccountNameCharacters);
                $(self.elements.textBox.accountName).on('paste', self.func.allowAccountNamePasting);
            },
            validateAccountName: function (accountName) {
                const accountNameRegex = new RegExp(self.constants.AllowedAccountNameRegex);
                const isValidFormat = accountNameRegex.test(accountName);

                const isValidLength = accountName.length <= self.constants.AccountNameMaxLength
                    && accountName.length >= self.constants.AccountNameMinimumLength;

                return isValidFormat && isValidLength;
            },
            validateSortCode: function (sortCode) {
                const sortCodeRegex = new RegExp(self.constants.NumberOnlyRegex);
                const isValidFormat = sortCodeRegex.test(sortCode);

                return isValidFormat && sortCode.length === self.constants.SortCodeRequiredLength;
            },
            validateAccountNumber: function (accountNumber) {
                const accountNumberRegex = new RegExp(self.constants.NumberOnlyRegex);
                const isValidFormat = accountNumberRegex.test(accountNumber);

                return isValidFormat && accountNumber.length === self.constants.AccountNumberRequiredLength;
            },
            allowOnlyNumbers: function (event) {
                let isControlCode = (event.charCode <= self.constants.CharCodeUnitSeperator);
                let isDecimalCode = (event.charCode >= self.constants.CharCodeNumericLowerBound &&
                    event.charCode <= self.constants.CharCodeNumericUpperBound);
                if (!isControlCode && !isDecimalCode) {
                    event.preventDefault();
                    return false;
                }
            },
            allowPastingofAccountNumbers: function (event) {
                event.preventDefault();
                let clipData = event.originalEvent.clipboardData.getData('text');
                if (clipData) {
                    let filtered = clipData.replace(self.constants.NotNumberRegexGlobal, '').slice(0, self.constants.AccountNumberRequiredLength);
                    event.target.value = filtered;
                }
            },
            allowPastingofSortCodeNumbers: function (event) {
                event.preventDefault();
                let clipData = event.originalEvent.clipboardData.getData('text');
                if (clipData) {
                    let filtered = clipData.replace(self.constants.NotNumberRegexGlobal, '').slice(0, self.constants.SortCodeRequiredLength);
                    event.target.value = filtered;
                }
            },
            allowOnlyAccountNameCharacters: function (event) {
                let regex = new RegExp(self.constants.AllowedAccountNameRegex);
                    const char = event.key;
                    if (!regex.test(char)) {
                        event.preventDefault();
                    }
            },
            allowAccountNamePasting: function (event) {
                    event.preventDefault();
                    const pastedData = event.originalEvent.clipboardData.getData('text');
                    if (pastedData) {
                        let regex = new RegExp('[^A-Za-z0-9 .\\-&/]', 'g');
                        let filtered = pastedData.replace(regex, '').slice(0, self.constants.AccountNameMaxLength);
                        event.target.value = filtered;
                    }
            },

            hideInvalidMessage: function () {
                $(self.elements.messages.invalidAccountName).addClass(self.css.vdsHiddenItem);
                $(self.elements.messages.invalidSortCode).addClass(self.css.vdsHiddenItem);
                $(self.elements.messages.invalidAccountNumber).addClass(self.css.vdsHiddenItem);

                $(self.elements.messages.incompleteAccountName).addClass(self.css.vdsHiddenItem);
                $(self.elements.messages.incompleteSortCode).addClass(self.css.vdsHiddenItem);
                $(self.elements.messages.incompleteAccountNumber).addClass(self.css.vdsHiddenItem);

                $(self.elements.messages.invalidCombination).addClass(self.css.vdsHiddenItem);
            },
            hideSpecificMessage: function (messageSelector) {
                $(messageSelector).addClass(self.css.vdsHiddenItem);
            },
            handleInvalidErrorMessages: function(accountName, sortCode, accountNumber){
                if (!self.func.validateAccountName(accountName)) {
                    self.func.handleInvalidAccountNameMessage(accountName);
                }
                if (!self.func.validateSortCode(sortCode)) {
                    self.func.handleInvalidSortCodeMessage(sortCode);
                }
                if (!self.func.validateAccountNumber(accountNumber)) {
                    self.func.handleInvalidAccountNumberMessage(accountNumber);
                }
            },
            handleInvalidAccountNameMessage: function (accountName) {
                if (accountName.length < self.constants.AccountNameMinimumLength){
                    $(self.elements.messages.incompleteAccountName).removeClass(self.css.vdsHiddenItem);
                } else {
                    $(self.elements.messages.invalidAccountName).removeClass(self.css.vdsHiddenItem);
                }
            },
            handleInvalidSortCodeMessage: function (sortCode) {
                if (sortCode.length < self.constants.SortCodeRequiredLength){
                    $(self.elements.messages.incompleteSortCode).removeClass(self.css.vdsHiddenItem);
                } else {
                    $(self.elements.messages.invalidSortCode).removeClass(self.css.vdsHiddenItem);
                }
            },
            handleInvalidAccountNumberMessage: function (accountNumber) {
                if (accountNumber.length < self.constants.AccountNumberRequiredLength){
                    $(self.elements.messages.incompleteAccountNumber).removeClass(self.css.vdsHiddenItem);
                } else {
                    $(self.elements.messages.invalidAccountNumber).removeClass(self.css.vdsHiddenItem);
                }
            },
            postCashbackBankDetailsUpdateRequest(accountName, sortCode, accountNumber){
                $.ajax({
                    type: 'POST',
                    url: self.urls.sendFormDataUrl,
                    data: {
                        accountName: accountName,
                        sortCode: sortCode,
                        accountNumber: accountNumber
                    },
                    success: function (response) {
                        if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                            window.location.href = self.urls.securityAndPaymentsPageUrl;
                        } else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                    error: function () {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
            handleSaveMemberCashBackandRewardDetails: function (event) {
                event.preventDefault();
                self.func.hideInvalidMessage();
                const accountName = $(self.elements.textBox.accountName).val();
                const sortCode = $(self.elements.textBox.sortCode).val();
                const accountNumber = $(self.elements.textBox.accountNumber).val();

                if(self.func.validateAccountName(accountName) &&
                    self.func.validateSortCode(sortCode) &&
                    self.func.validateAccountNumber(accountNumber)
                ){
                    $.ajax({
                        type: 'POST',
                        url: self.urls.validateBankDetails,
                        data: {
                            sortCode: sortCode,
                            accountNumber: accountNumber
                        },
                        success: function(data){
                            if (data.messageCode === self.constants.SuccessMessageCode) {
                                self.func.postCashbackBankDetailsUpdateRequest(accountName, sortCode, accountNumber);
                            } else {
                                $(self.elements.messages.invalidCombination).removeClass(self.css.vdsHiddenItem);
                            }
                        },
                        error: function() {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    });
                } else {
                    self.func.handleInvalidErrorMessages(accountName, sortCode, accountNumber);
                }
            },
        }

    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('memberCashbackAndRewardsUpdate' === $('#member-form').data('feature')) {
        window.UpdateCashbackAndRewardsForm.Init();
    }
});
